var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6665 8.3335H8.33317C6.0415 8.3335 4.18734 10.2085 4.18734 12.5002L4.1665 37.5002C4.1665 39.7918 6.0415 41.6668 8.33317 41.6668H41.6665C43.9582 41.6668 45.8332 39.7918 45.8332 37.5002V12.5002C45.8332 10.2085 43.9582 8.3335 41.6665 8.3335ZM41.6665 16.6668L24.9998 27.0835L8.33317 16.6668V12.5002L24.9998 22.9168L41.6665 12.5002V16.6668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7a899d03a389ef94df2ad9dfe702ec91.svg";
export { ForwardRef as ReactComponent };